import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { observable, action, makeObservable } from 'mobx';
export type assignUserToGroupsOnSaveCallback = (userId: string, emailAddress: string, displayName: string) => void;

export class AssignUserModalView {
    @observable isModalShown: boolean;
    @observable selectedUserFromSuggestion: Nullable<ISuggestedUser>;
    masterAccountId: string;
    onSaveCallback: assignUserToGroupsOnSaveCallback;

    constructor(maid: string, callBack: assignUserToGroupsOnSaveCallback) {
        makeObservable(this);
        this.masterAccountId = maid;
        this.onSaveCallback = callBack;
        this.isModalShown = false;
    }

    getSearchSuggestionText(user: ISuggestedUser): string {
        return user.displayName;
    }

    @action
    clearFoundUser(): void {
        this.selectedUserFromSuggestion = null;
    }

    searchUsers(searchText: string, resultLimit: number, includeAll: boolean): Promise<Nullable<ISuggestedUser[]>> {
        const userDataManager = dataManagerFactory.getUserDataManager();
        return userDataManager.getSuggestedUsers(
            this.masterAccountId,
            searchText,
            resultLimit,
            includeAll
        );
    }

    @action
    setFoundUser(user: ISuggestedUser): void {
        this.selectedUserFromSuggestion = user;
    }

    @action
    showModal(): void {
        this.isModalShown = true;
    }

    @action
    hideModal(): void {
        this.isModalShown = false;
    }

    @action
    save(): void {
        if (!this.selectedUserFromSuggestion) {
            return;
        }

        this.onSaveCallback(
            this.selectedUserFromSuggestion.userId,
            this.selectedUserFromSuggestion.emailAddress,
            this.selectedUserFromSuggestion.displayName);
        this.hideModal();
    }
}